<template>
    <modal id="faqs-modal"
           v-model="showModal"
           :title="generateModalTitle('faq')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
           size="large"
    >
        <form method="post" ref="form" :data-url="selectedUrl ? selectedUrl : apiUrl.FAQS">
            <app-form-group
                :label="$t('question')"
                v-model="formData.question"
                :placeholder="$placeholder('question')"
                :errorMessage="$errorMessage(errors, 'question')"
            />
            <div class="form-group">
                <label for="text-editor-for-template">{{ $t('answer') }}</label>
                <app-input
                    type="text-editor"
                    v-model="formData.answer"
                    :placeholder="$placeholder('answer')"
                    :errorMessage="$errorMessage(errors, 'answer')"
                    id="text-editor-for-template"
                />
            </div>
        </form>
    </modal>
</template>

<script>
    import ModalMixin from "../../../../Mixins/ModalMixin";
    import FromHelperMixin from "../../../../Mixins/FormHelperMixin";

    export default {
        name: "FaqCreateEdit",
        mixins: [ModalMixin, FromHelperMixin],
        methods: {
            afterSuccess({data}) {
                this.toastAndReload(data.message, 'faqs-table');
                this.$emit('input', false);
                $('#faqs-modal').modal('hide');
            }
        }
    }
</script>

<style scoped>

</style>